import { takeLatest } from 'redux-saga/effects';
import { authActions } from 'reducer';

export default function* profileSaga() {
  yield takeLatest(authActions.loginSuccess, function*() {});
}
